import Modal from 'react-modal';

export default ({ children, x, y, width, height, isOpen, onClose }) => {
  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    content: {
      top: `${y}px`,
      left: `${x}px`,
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width,
      height,
      // transform: 'translate(-50%, 45px)',
      background: 'none',
      borderRadius: '0',
      border: 'none',
      outline: 'none',
      padding: '0',
      overflow: 'visible',
      display: 'flex',
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      ariaHideApp={false}
      contentLabel="Modal"
    >
      <div className="z-10 w-full min-h-full overflow-hidden rounded-md shadow-3xl">{children}</div>
    </Modal>
  );
};
